import Button from "./Button"
// import hero from "../hero.png"
import blog from "../blog.png"
import { NavLink} from "react-router-dom"
import crypto from "../images/crypto.png"
import tracker from "../images/Screenshot.png"
import memory from "../images/Screenshotmemories.png"
import logoreact from "../react_logo.png"
import nodejslogo from "../nodejs_logo.png"
import mongodblogo from "../mongodblogo.png"
import expresslogo from "../express_logo.png"
import materialui from "../images/materialui.png"
import rapedapi from "../images/rapedapi.png"
import redux from "../images/redux.png"
import ant from "../images/ant.jpeg"
import javascriptlogo from "../javascript_logo.png"
import { Typography, Box, Paper,Grid, ButtonBase } from '@material-ui/core'
import Typical from 'react-typical'
import CryptoConveter from './CryptoConveter'
// import CssBaseline from "@material-ui/core/CssBaseline"


const steps = [
    'Hello 👋', 1000,
    'I am Asaf Shapira', 1000,
    'I am FullStack Developer👌', 1000,
    'I can building  ', 2000,
    'I can implementing', 2000,
    'I can Designing & developing RESTful APIs', 3000,
    'Working from concept to completion', 2000,
    'Working with advanced technologies', 2000,
    'Contact Me dna0187@gmail.com'
  ];










export default function Hero() {
    return (
        <>
            <section className="hero3">
                <div>
                    <Typical wrapper="span" steps={steps} loop={1} className="script1" />
                </div>
            </section>
            <section >
                <div className="overlay">
                    <article  >
                        <h1 className="font-bold">working with a range a <span className="text-green-500">technoloies </span> in the web development world. From Back-end <span className='text-green-500'> To </span> Design</h1>
                        <article className="mt-3">
                            <Button />
                        </article>
                    {/* <article className="hero-image" >
                        <div className="cube" id="react"></div>
                        <div className="cube" id="javascript"></div>
                        <div className="cube" id="moongo"></div>
                        <div className="cube" id="node"></div>
                        <div className="cube" id="ann"></div>
                    </article> */}
                    </article>
                </div>
            </section>
            <hr />
            <section className="s1">
                <div className="main-container">
                    <h2 className="headings">PORTFOLIO</h2>
                    <div className="post-wrapper">
                            <div className="post">
                                <img className="thumbnail" src={tracker} alt=""/>
                                <div className="post-preview">
                                    <h4 className="post-title">Dudget tracker</h4>
                                    <p className="post-intro"><strong>Technologies:</strong> React & JavaScript. State Management in React, Context API, Local Storage, Material UI. scalable React folder structure. voice capabilitie application using Speechly. 
                                    </p>
                                    <div style={{display: 'flex', marginBottom: '10px'}}>
                                    <img style={{width:'35px', height:'35px'}} src={javascriptlogo} alt=""/>
                                    <img style={{width:'55px', height:'35px'}} src={materialui} alt=""/>
                                    </div>
                                    <a href="https://dudget-tracker-as.netlify.app">TRY ME</a>
                                    <div className="cta1">
                                        <a href="https://github.com/superas0187/tracker/tree/master" activeClassName="activeBtn" className="bg-green-500 py-2 px-3 rounded shadow transition-all duration-300 hover:bg-transparent hover:text-green-500 border-green-500" >
                                            <button   >
                                                <ion-icon name="star" /> On Github
                                            </button>
                                        </a>
                                    </div> 
                                </div>
                            </div>
                    <div className="post">
                        <img className="thumbnail" src={crypto} alt=""/>
                        <div className="post-preview">
                            <h4 className="post-title">cryptocurrencies</h4>
                            <p className="post-intro"><strong>Technologies:</strong> State Management using Redux Toolkit, UI Creation using Ant Design, creating charts using Chart.js, and fetching data from multiple sources using RapidAPI
                            </p>
                            <div style={{display: 'flex', marginBottom: '10px'}}>
                            <img style={{width:'30px', height:'30px', marginRight: '5px'}} src={rapedapi} alt=""/>
                            <img style={{width:'30px', height:'30px'}} src={ant} alt=""/>
                            <img style={{width:'30px', height:'30px', marginLeft: '5px'}} src={redux} alt=""/>
                            </div>
                            <a  href="https://cryptocurrencies-by-api-mastery.netlify.app">TRY ME</a>
                            <div className="cta1">
                                        <a href="https://github.com/superas0187/cryptocurrencies/tree/master" activeClassName="activeBtn" className="bg-green-500 py-2 px-3 rounded shadow transition-all duration-300 hover:bg-transparent hover:text-green-500 border-green-500" >
                                            <button   >
                                                <ion-icon name="star" /> On Github
                                            </button>
                                        </a>
                                    </div> 
                        </div>
                    </div>
                    <div className="post">
                        <img className="thumbnail" src={memory} alt=""/>
                        <div className="post-preview">
                            <h4 className="post-title">Event</h4>
                            <p className="post-intro"><strong>Technologies:</strong>Full Stack MERN Social Media App, Using React, Node JS, Express & MongoDB implement MERN pagination, title & tags search, and client-side routing to a post details page.</p>
                            <div style={{display: 'flex'}}>
                                {/* <img style={{width:'30px', height:'30px', marginRight: '5px'}} src={expresslogo } alt=""/> */}
                                <img style={{width:'50px', height:'50px'}} src={nodejslogo} alt=""/>
                                <img style={{width:'50px', height:'50px', marginLeft: '5px'}} src={mongodblogo} alt=""/>
                            </div>
                            <div className="cta1">
                                        <a href="https://github.com/superas0187/superas0187/" activeClassName="activeBtn" className="bg-green-500 py-2 px-3 rounded shadow transition-all duration-300 hover:bg-transparent hover:text-green-500 border-green-500" >
                                            <button   >
                                                <ion-icon name="star" /> On Github
                                            </button>
                                        </a>
                                    </div> 
                        </div>
                    </div>
                </div>
                </div>
            </section>
            <section>
                <div className='currency'>
                    <CryptoConveter />
                </div>
            </section>
            <hr />
            
        </>
    )
}
